import Typography from '@mui/material/Typography'
import React, { useEffect, useState } from 'react'

interface Props {
   filename: string
   producerName: string
   producerUuid: string
   height?: number | string
   width?: number | string
}

export default function ImageComponent({ filename, producerUuid, height, width, producerName }: Props) {
   const [error, setError] = useState(false)
   const imageUrl = `https://files.motorro.eu/img/logos-producers/light/${producerUuid}.png`

   useEffect(() => {
      setError(false)
   }, [filename])

   const getFontSize = (text: string) => {
      const { length } = text
      if (length <= 5) return '1.5rem'
      if (length <= 10) return '1.2rem'
      if (length <= 20) return '1rem'
      return '0.8rem'
   }

   return error ? (
      <Typography
         sx={{
            fontSize: getFontSize(producerName || 'NIEZNANY'),
            textAlign: 'center',
            fontWeight: 'bold',
         }}
      >
         {producerName ? producerName.toUpperCase() : 'NIEZNANY'}
      </Typography>
   ) : (
      <img
         src={imageUrl}
         style={{
            verticalAlign: 'middle',
            margin: '0 auto',
            display: error ? 'none' : 'block',
            height: height ?? 20,
            width: width ?? 'auto',
         }}
         alt={producerName}
         onError={() => {
            setError(true)
         }}
      />
   )
}
